<div class="contentModal">
    <h1 mat-dialog-title style="color: #3074AA;"><Strong>Lista de Históricos da Máquina</Strong></h1>
    <h4 mat-dialog-title style="color: #3074AA;">Nome: {{nome}}</h4>

    <div class="consulta">
        <div class="container-table">
            <div class="row justify-content-md-center" *ngIf="isFetching">
                <mat-spinner class="spinner" [color]="primary" [mode]="indeterminate" [value]="50"></mat-spinner>
            </div>
            <table mat-table [dataSource]="dataSource" *ngIf="!isFetching" class="mat-elevation-z8">

                <ng-container matColumnDef="situacao">
                    <th mat-header-cell *matHeaderCellDef class="text-center"> Situação </th>
                    <td mat-cell *matCellDef="let element" class="text-center"> {{element.situacao}} </td>
                </ng-container>

                <ng-container matColumnDef="dataAlteracao">
                    <th mat-header-cell *matHeaderCellDef class="text-center"> Data de Alteração </th>
                    <td mat-cell *matCellDef="let element" class="text-center"> {{element.dataAlteracao}} </td>
                </ng-container>   

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <mat-paginator 
                showFirstLastButtons
                class="paginacao" 
                [pageSizeOptions]="pageSizeOptions" 
                [length]="length" 
                [pageSize]="pageSize"
                [pageIndex]="pageIndex"
                 (page)="pesquisar($event)"
                [disabled]="paginacao">
            </mat-paginator>
        </div>
    </div>

    <div mat-dialog-actions class="botoes">
        <button mat-button mat-dialog-close  class="md-icon-button btnNok">Fechar</button>
    </div>
 </div>
